import { IUser } from "../../user/IUser";
import { isPremium } from "../../utils";
import { IMenuItem } from "../IMenu";
import { ddPro } from "./en";

export const freeTrial: IMenuItem = {
  label: "Testa gratis",
  href: "/se/ny-medlem"
};

export const becomeMemberPayment: IMenuItem = {
  label: "Testa gratis",
  href: "/se/bli-medlem/payment"
};

export const login: IMenuItem = {
  label: "Logga in",
  href: "/se/login"
};

export const logout: IMenuItem = {
  label: "Logga ut"
};

export const shoppingList: IMenuItem = {
  label: "Inkopslista",
  href: "/se/inkopslista"
};

export const tracking: IMenuItem = {
  label: "Mina viktforandring",
  href: "/se/viktforandring"
};

export const appCta: IMenuItem = {
  label: "Diet Doctor Eat app"
};

export const stores: IMenuItem[] = [
  {
    label: "App Store",
    href: "https://apps.apple.com/us/app/diet-doctor-eat/id1440002708?itsct=apps_box&itscg=30200"
  },
  {
    label: "Play Store",
    href: "https://play.google.com/store/apps/details?id=com.dietdoctor.EatApp&utm_source=app_page&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
  }
];

export const myAccount: IMenuItem = {
  label: "Mitt konto",
  children: [
    {
      label: "Mina personliga inställningar",
      href: "/se/anvandare/installningar"
    },
    {
      label: "Mina matpreferenser",
      href: "/se/anvandare/matpreferenser"
    },
    {
      label: "Mina favoriter",
      href: "/se/medlem/favoriter",
      onlyPremium: true
    },
    {
      label: "Mina veckomenyer",
      href: "/se/medlem/veckomenyer/mina-veckomenyer",
      onlyPremium: true
    },
    {
      label: "Min inköpslista",
      href: "/se/inkopslista",
      onlyPremium: true
    },
    {
      label: "Mitt medlemskap",
      href: "/se/medlem/mitt-konto",
      onlyPremium: true
    },
    {
      label: "Kommunikationsval",
      href: "/se/braze/preference-center",
    },
    {
      label: "Min viktförändring",
      href: "/se/viktforandring"
    },
    {
      label: "Kostprogram",
      href: "/se/kostprogram"
    },
    {
      label: "Help Center",
      href: "https://dietdoctor.zendesk.com/hc/sv"
    },
    {
      label: "Medlemsförmåner",
      href: "/se/utforska-dd-plus"
    }
  ]
};

export const all: IMenuItem[] = [
  { ...ddPro },
  {
    label: "Meny",
    children: [
      {
        label: "Kostupplägg",
        children: [
          {
            label: "LCHF",
            children: [
              {
                label: "LCHF för nybörjare",
                href: "/se/lchf"
              },
              {
                label: "Samtliga guider",
                href: "/se/lchf/guider"
              },

              {
                label: "Kostråd",
                href: "/se/lchf/lchf-mat"
              },
              {
                label: "Visuella guider",
                href: "/se/visuella-guider-till-lchf"
              },
              {
                label: "Biverkningar",
                href: "/se/lchf/biverkningar"
              },
              {
                label: "14 dagar med lågkolhydratkost",
                href: "/se/lchf/14-dagar-med-lagkolhydratkost"
              },
              {
                label: "Recept",
                href: "/se/lchf/recept"
              },
              {
                label: "Veckomenyer",
                href: "/se/medlem/veckomenyer/mattlig-lchf"
              }
            ]
          },
          {
            label: "Keto",
            children: [
              {
                label: "Keto för nybörjare",
                href: "/se/lchf/keto"
              },
              {
                label: "Samtliga guider",
                href: "/se/lchf/guider"
              },
              {
                label: "Kostråd",
                href: "/se/lchf/keto/mat"
              },
              {
                label: "Visuella guider",
                href: "/se/visuella-guider-till-lchf"
              },
              {
                label: "Omställningsbesvär",
                href: "/se/lchf/keto/omstallningsbesvar"
              },
              {
                label: "14 dagar med keto",
                href: "/se/lchf/keto/kostplan"
              },
              {
                label: "Recept",
                href: "/se/lchf/keto-recept"
              },
              {
                label: "Veckomenyer",
                href: "/se/medlem/veckomenyer/ketogena-veckomenyer"
              }
            ]
          },
          {
            label: "Proteinrik mat",
            children: [
              {
                label: "Proteinrik mat: Vad det är och hur du gör",
                href: "/se/proteinrik-mat/hub"
              },
              {
                label: "Den bästa proteinrika maten för viktnedgång",
                href: "/se/proteinrik-mat/livsmedlen"
              },
              {
                label: "Topp 10 – proteinrika livsmedel",
                href: "/se/lchf/protein-och-lchf/topp-10"
              },
              {
                label: "Snacks",
                href: "/se/proteinrik-mat/proteinrika-snacks"
              },
              {
                label: "14 dagar med proteinrik mat",
                href: "/se/proteinrik-mat/14-dagar-veckomeny"
              },
              {
                label: "Recept",
                href: "/se/proteinrik-mat/recept"
              },
              {
                label: "Veckomenyer",
                href: "/se/proteinrik-mat/veckomenyer"
              }
            ]
          },
          {
            label: "Periodisk fasta",
            href: "/se/periodisk-fasta"
          },
          {
            label: "Samtliga guider",
            href: "/se/lchf/guider"
          },
          {
            label: "FAQ - lågkolhydratkost",
            href: "/se/faq-lagkolhydratkost"
          },
          {
            label: "Diet Doctors matfilosofi",
            href: "/se/matfilosofi"
          }
        ]
      },
      {
        label: "Viktnedgång",
        children: [
          {
            label: "Kostprogram",
            href: "/se/kostprogram"
          },
          {
            label: "Hälsosam viktnedgång",
            href: "/se/viktnedgang"
          },
          {
            label: "Gå ner i vikt snabbt",
            href: "/se/viktnedgang/svart-ga-ner-i-vikt"
          },
          {
            label: "Våra 10 bästa tips för att komma till rätta med en viktplatå",
            href: "/se/viktnedgang/svart-ga-ner-i-vikt/viktplata"
          },
          {
            label: "De 10 bästa viktminskningsprogrammen",
            href: "/se/viktnedgang/svart-ga-ner-i-vikt/10-viktminskningsprogram"
          },
          {
            label: "5 tips för viktnedgång",
            href: "/se/de-5-basta-tipsen-vikten"
          },
          {
            label: "Framgångshistorier",
            href: "/se/kategori/viktnedgang/vikthistorier"
          },
          {
            label: "Allt om hälsosam viktnedgång",
            href: "/se/allt-du-behover-veta-for-att-ga-ner-i-vikt-pa-ett-halsosamt-satt"
          }
        ]
      },
      {
        label: "Veckomenyer",
        children: [
          {
            label: "Mina veckomenyer",
            href: "/se/medlem/veckomenyer/mina-veckomenyer",
            onlyPremium: true,
            disabled: (user: IUser) => !isPremium(user)
          },
          {
            label: "Personliga veckomenyer",
            href: "/se/medlem/veckomenyer/personliga",
            onlyPremium: true
          },
          {
            label: "Alla veckomenyer",
            href: "/se/medlem/veckomenyer/alla"
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "LCHF",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Alla måttliga veckomenyer",
                href: "/se/medlem/veckomenyer/mattlig-lchf"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Vegetariska",
                href: "/se/medlem/veckomenyer/vegetariska-veckomenyer"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Mejerifria",
                href: "/se/medlem/veckomenyer/veckomenyer-utan-mejeriprodukter"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Favoriter",
                href: "/se/medlem/veckomenyer/diet-doctors-favoriter"
              }
            ]
          },
          {
            label: "Keto",
            href: "/se/medlem/veckomenyer/ketogena-veckomenyer",
            onlyPremium: true
          },
          {
            label: "Proteinrika",
            href: "/se/proteinrik-mat/veckomenyer",
            onlyPremium: true
          },
          {
            label: "LCHF Exempelveckomeny",
            href: "/se/lchf/14-dagar-med-lagkolhydratkost",
            guard: (user: IUser) => !isPremium(user)
          },
          {
            label: "Keto Exempelveckomeny",
            href: "/se/lchf/keto/kostplan",
            guard: (user: IUser) => !isPremium(user)
          }
        ]
      },
      {
        label: "Recept",
        children: [
          {
            label: "Mina favoritrecept",
            href: "/se/medlem/favoriter",
            onlyPremium: true
          },
          {
            label: "LCHF-recept",
            href: "/se/lchf/recept"
          },
          {
            label: "Keto-recept",
            href: "/se/lchf/keto-recept"
          },
          {
            label: "Proteinrika recept",
            href: "/se/proteinrik-mat/recept"
          },
          {
            label: "Receptsamlingar",
            href: "/se/lchf/recept/samlingar"
          },
          {
            label: "Alla recept",
            href: "/se/?s="
          },
          {
            label: "Matlagningsvideo",
            href: "/se/medlem/matlagningsvideo"
          },
          {
            label: "FAQ - Recept",
            href: "/se/lchf/recept/faq"
          }
        ]
      },
      {
        label: "Hälsa",
        children: [
          {
            label: "Diabetes",
            children: [
              { label: "Diabetes - resurser", href: "/se/samlingssida-diabetes" },
              { label: "Så reverserar du typ 2-diabetes", href: "/se/diabetes" },
              { label: "Kost vid diabetes", href: "/se/diabetes/kost" },
              { label: "Grundkurs i typ 2-diabetes", href: "/se/typ-2-diabetes" },
              {
                label: "Hur du kan behandla insulinresistens",
                href: "/se/halsa/hur-du-behandlar-insulinresistens"
              },
              { label: "Blodsocker och diabetes", href: "/se/diabetes/blodsocker-och-diabetes" },
              { label: "Diabetesprogrammet - Anmäl dig här!", href: "/se/diabetesprogrammet" }
            ]
          },
          {
            label: "Blodtryck",
            children: [
              { label: "Blodtryck - resurser", href: "/se/samlingssida-blodtryck" },
              {
                label: "Allt du behöver veta om högt blodtryck",
                href: "/se/blodtryck/allt-du-behover-veta-om-hogt-blodtryck"
              },
              { label: "Vad är normalt blodtryck?", href: "/se/blodtryck/normalt" },
              {
                label: "Blodtrycksmedicin: de 4 vanligaste grupperna",
                href: "/se/blodtryck/blodtrycksmediciner"
              },
              { label: "Snabbkurs i blodtryck	", href: "/se/blodtryck" }
            ]
          },
          {
            label: "Kolesterol",
            children: [
              { label: "Kolesterol - resurser", href: "/se/samlingssida-kolesterol" },
              { label: "Vad är kolesterol?", href: "/se/vad-ar-kolesterol" },
              {
                label: "Så sänker du ditt LDL-kolesterol på lågkolhydratkost",
                href: "/se/lchf/sanka-ldl-kolesterol"
              },
              {
                label: "Är förhöjt LDL-kolesterol farligt?",
                href: "/se/kolesterol/ar-forhojt-ldl-kolesterol-farligt"
              },
              { label: "Hälsosamma val av fett", href: "/se/lchf/fett" }
            ]
          },
          {
            label: "Alla guider om metabol hälsa",
            href: "/se/halsa"
          }
        ]
      },
      {
        label: "Video & kurser",
        children: [
          {
            label: "Video",
            href: "/se/video"
          },
          {
            label: "Kurser",
            href: "/se/medlem/kurs"
          },
          {
            label: "Filmer",
            href: "/se/medlem/filmer"
          },
          {
            label: "Intervjuer",
            href: "/se/medlem/intervjuer"
          },
          {
            label: "Föreläsningar",
            href: "/se/medlem/forelasningar"
          },
          {
            label: "Kostprogram",
            href: "/se/kostprogram"
          },
          {
            label: "Upptäck",
            href: "/se/utforska-dd-plus"
          }
        ]
      }
    ]
  },
  {
    children: [
      {
        ...freeTrial
      },
      {
        ...login
      }
    ]
  },
  {
    children: [
      {
        label: "Guider",
        href: "/se/lchf/guider"
      },
      {
        label: "Nyheter",
        href: "/se/nyheter"
      },
      {
        label: "Professorn svarar",
        href: "/se/professorn-svarar"
      },
      {
        label: "Kostprogram",
        href: "/se/kostprogram"
      },
      {
        label: "Sociala medier",
        children: [
          {
            label: "Instagram",
            href: "https://www.instagram.com/dietdoctor_se"
          },
          {
            label: "Facebook",
            href: "https://www.facebook.com/dietdoctorsverige"
          },
          {
            label: "YouTube",
            href: "https://www.youtube.com/user/Kostdoktorn"
          }
        ]
      },
      {
        label: "Framgångshistorier",
        href: "/se/kategori/viktnedgang/vikthistorier"
      },
      {
        label: "Bloggnytt",
        href: "/se/nytt"
      },
      {
        label: "Om oss",
        children: [
          {
            label: "Om Diet Doctor",
            href: "/se/om"
          },
          {
            label: "Teamet",
            href: "/se/om/team-diet-doctor-se"
          },
          {
            label: "Medlemskap",
            href: "/se/utforska-dd-plus"
          },
          {
            label: "Berättelsen om Diet Doctor",
            href: "/se/om/berattelsen-om-diet-doctor"
          }
        ]
      },
      {
        label: "DD Partnerships",
        href: "/se/dd-partnership"
      },
      {
        label: "Support",
        href: "https://dietdoctor.zendesk.com/hc/sv"
      }
    ]
  }
];
